import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import { createPlugin } from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes } from './routes';

export const confidencePulsePlugin = createPlugin({
  id: 'confidence-pulse',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindPulseRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(confidencePulsePlugin.externalRoutes),
    convertLegacyRouteRefs({ ...extraRoutes }),
  );
};
